<template>
  <div
    class="resolveEnquete"
  >
    <div>
      <div class="resolveButtonArea">
        <div class="buttonWrapper">
          <a
            :class="['resolveButton', showLastMessage && 'disabled']"
            @click.prevent="resolved"
          >
            {{ resolveMessage }}
          </a>
          <a
            :class="['resolveButton', showLastMessage && 'disabled']"
            @click.prevent="unresolved"
          >
            {{ unsolvedMessage }}
          </a>
        </div>
      </div>
    </div>
    <div id="sai-reset"></div>
    <div v-show="showLastMessage">
      <div class="lastMessage sai-caption" v-html="afterFeedbackMessage">
      </div>
      <div class="resolveButtonArea reset">
        <a @click.prevent="reset" class="resolveButton">回答を閉じる</a>
      </div>
    </div>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import ResourceListFooterMixin from '@/mixins/ResourceListFooterMixin';
import Const from '../const/index';
import { eventBus } from '@/eventBus';
import { Watch } from 'vue-property-decorator';

@Component({})
export default class ResourceListFooter extends mixins(
  ResourceListFooterMixin
) {
  resolveMessage = Const.ASK_FEEDBACK_CHOICES.RESOLVED;
  unsolvedMessage = Const.ASK_FEEDBACK_CHOICES.UNRESOLVED;
  afterResulvedMessage = Const.AFTER_RESOLVED_MESSAGE;
  afterUnResulvedMessage = Const.AFTER_UNRESOLVED_MESSAGE;

  @Watch('showLastMessage')
  onChangeResultHeight() {
    setTimeout(() => {
      eventBus.$emit('updateRecommendHeight');
    }, 0);
  }
  get afterFeedbackMessage() {
    if (this.feedbackResult === 'unresolved') {
      return this.afterUnResulvedMessage;
    }
    return this.afterResulvedMessage;
  }
  async resolved() {
    this.feedbackResult = 'resolved';
    this.setShowLastMessage(true);

    this.$store.commit('ticket/setResetFlag', true);
    const newTicket = this.updateTicket({
      item: this.currentValue,
      feedback: 'resolved',
    });
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
  async unresolved() {
    this.feedbackResult = 'unresolved';
    this.setShowLastMessage(true);

    this.$store.commit('ticket/setResetFlag', true);
    const newTicket = this.updateTicket({
      item: this.currentValue,
      feedback: 'unresolved',
    });
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
  async reset(e) {
    this.$emit('resetItem');
    if (this.$store.state.ticket.resetFlag) {
      eventBus.$emit('resetTicket');
      return;
    }
    const newTicket = this.generateClearTicket();
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
  initFeedbackData() {
    this.showLastMessage = false;
    this.feedbackResult = '';
  }
  created() {
    eventBus.$on('initFeedbackData', () => {
      this.initFeedbackData();
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../style/settings';
@import '../style/component/FaqClientPc';
@import '../style/utility/embedHtml';

.resolveButtonArea {
  padding: 12px 0 0 0;
  background-color: #f1ffd8;
  text-align: center;

  &.reset {
    padding: 0 !important;
    background-color: #f1ffd8 !important;

    .resolveButton {
      background-color: #333 !important;
      color: #fff !important;
    }
  }
}

.buttonWrapper {
  text-align: center;
}

.resolveButton {
  display: inline-block !important;
  margin: 6px !important;
  padding: 6px 30px !important;
  font-size: 12px !important;
  text-align: center !important;
  border: 1px solid transparent !important;
  border-radius: 18px !important;
  background-color: #fff !important;
  background-image: none !important;
  cursor: pointer !important;
  -webkit-tap-highlight-color: transparent !important;

  &.disabled {
    pointer-events: none !important;
    background-color: #eee !important;
    color: #757575 !important;
  }

  // resolve mutual influence with client css
  &::after {
    display: none !important;
  }

  .mobile & {
    font-size: 11px !important;
    padding: 4px 24px !important;
  }
}

.lastMessage {
  font-size: 12px !important;
  padding: 12px 32px;
  text-align: center;
  background-color: #f1ffd8;

  .mobile & {
    font-size: 11px !important;
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/ResourceListFooter.vue